import { useLanguage } from "../../i18n/LanguageContext";
import { ContactCards } from "../ContactCards";
import { InquiryButton } from "../BookingButton";
import { Reveal } from "../Reveal";

export const ContactCTA = () => {
  const { t } = useLanguage();
  return (
    <section className="section !pt-0" data-testid="contact-cta-section">
      <div className="container-x grid gap-12 lg:grid-cols-12">
        <Reveal className="lg:col-span-5">
          <p className="eyebrow">{t.contactCta.eyebrow}</p>
          <h2 className="h2 mt-4">{t.contactCta.title}</h2>
          <p className="lede mt-6">{t.contactCta.text}</p>
          <InquiryButton variant="primary" className="mt-8 !px-7 !py-3.5" label={t.cta.contactForm} testId="contact-cta-form-button" />
        </Reveal>
        <Reveal className="lg:col-span-7" delay={0.1}>
          <ContactCards />
        </Reveal>
      </div>
    </section>
  );
};
